var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M25.402,144.696C9.128,178.352,0,216.11,0,256s9.128,77.648,25.402,111.304L256,389.565 l230.598-22.261C502.872,333.648,512,295.89,512,256s-9.128-77.648-25.402-111.304L256,122.435L25.402,144.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M25.411,367.304C66.818,452.934,154.507,512,256,512s189.183-59.066,230.589-144.696H25.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M25.411,144.696h461.178C445.183,59.066,357.493,0,256,0S66.818,59.066,25.411,144.696z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "211.478,322.783 300.522,322.783 300.522,284.939 282.713,293.843 256,267.13  229.287,293.843 211.478,284.939  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "160.532,278.261 164.677,291.015 178.087,291.015 167.237,298.898 171.382,311.652  160.532,303.77 149.682,311.652 153.827,298.898 142.977,291.015 156.387,291.015  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "173.381,233.739 177.526,246.493 190.936,246.493 180.086,254.376 184.23,267.13  173.381,259.248 162.531,267.13 166.676,254.376 155.826,246.493 169.236,246.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "210.113,200.348 214.258,213.102 227.667,213.102 216.819,220.985 220.962,233.739  210.113,225.857 199.264,233.739 203.408,220.985 192.558,213.102 205.969,213.102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "351.468,278.261 347.323,291.015 333.913,291.015 344.763,298.898 340.618,311.652  351.468,303.77 362.317,311.652 358.173,298.898 369.023,291.015 355.613,291.015  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "338.619,233.739 334.474,246.493 321.064,246.493 331.914,254.376 327.769,267.13  338.619,259.248 349.469,267.13 345.324,254.376 356.174,246.493 342.764,246.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "301.887,200.348 297.742,213.102 284.333,213.102 295.181,220.985 291.037,233.739  301.887,225.857 312.736,233.739 308.592,220.985 319.441,213.102 306.031,213.102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,183.651 260.145,196.405 273.555,196.405 262.705,204.288 266.85,217.042 256,209.16  245.15,217.042 249.295,204.288 238.445,196.405 251.855,196.405  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/tj.114b6368e54c3d905b32f6584f59e0eb.svg";
export { ForwardRef as ReactComponent };